import PropTypes from "prop-types";
import React, { useState, useReducer } from "react";
import Filter from "../filter";
import FilterContent from "../filter-content";
import BasicModal from "../../elements/basic-modal";

export default function MixedContentGridFilter({
  filterContentProps,
  filterProps
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedFilters, dispatch] = useReducer(
    (selectedFilters, { type, value }) => {
      let returnedFilters;
      switch (type) {
        case "add":
          returnedFilters = value;
          filterProps.addFilterCallback(returnedFilters);
          break;
        case "remove":
          returnedFilters = selectedFilters.filter(
            (_, index) => index !== value
          );
          filterProps.clearFilterCallback(returnedFilters);
          break;
        case "remove_all":
          returnedFilters = [];
          filterProps.resetAllCallback(returnedFilters);
          break;
        default:
          returnedFilters = selectedFilters;
          break;
      }
      return returnedFilters;
    },
    filterProps.selectedOptions
  );

  const addFilters = filters => {
    dispatch({ type: "add", value: filters });
  };

  const clearFilter = index => {
    dispatch({ type: "remove", value: index });
  };
  const resetAll = () => {
    dispatch({ type: "remove_all", value: 0 });
  };

  return (
    <div className="mixed-content-grid-filter">
      <Filter
        heading={filterProps.heading}
        resetText={filterProps.resetText}
        selectedFilters={selectedFilters}
        onFilterIconClick={() => {
          setShowModal(true);
        }}
        onResetAllFilter={resetAll}
        onClearFilter={clearFilter}
      />
      {showModal && (
        <BasicModal
          {...{
            withShadow: false,
            screenSettings: {
              fullWidth: false,
              fullScreen: true,
              fullHeight: true
            },
            onCloseClicked: () => setShowModal(false),
            id: "filter-modal",
            closeIconBackground: true
          }}
        >
          <FilterContent
            {...{
              ...filterContentProps,
              filterOptions: filterProps.filterOptions,
              selectedOptions: selectedFilters,
              onFilterSelect: selectedFilters => {
                addFilters(selectedFilters);
                setShowModal(false);
              }
            }}
          />
        </BasicModal>
      )}
    </div>
  );
}

MixedContentGridFilter.propTypes = {
  filterContentProps: PropTypes.shape({
    heading: PropTypes.object,
    sliderImages: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string,
        logo: PropTypes.string,
        url: PropTypes.string
      })
    ),
    submitText: PropTypes.string
  }),
  filterProps: PropTypes.shape({
    heading: PropTypes.string,
    resetText: PropTypes.string,
    filterOptions: PropTypes.object,
    selectedOptions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string
      })
    ),
    addFilterCallback: PropTypes.func,
    clearFilterCallback: PropTypes.func,
    resetAllCallback: PropTypes.func
  })
};
